import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import styles from "../ModalStyle";
import IFrameRenderer from "../../../../common/IFrameRenderer";

const ProImages = (props) => {
    const { classes} = props;
    return (
        <div>
        <Dialog
          open={props.show}
          onClose={props.onClose}
          aria-labelledby="popup-title"
          classes={{ paper: classes.imagesContainer }}
          maxWidth="xl"
        >
          <DialogTitle
            id="popup-title"
            classes={{ root: classes.title }}
            disableTypography
          >
            Images for Pro : {props.proNumber}
            <IconButton onClick={props.onClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.content}>
            <div className={classes.imagesGridContainer}>
              { props.url ? (
                  <IFrameRenderer
                  url={props.url}
                />
              ) : <div className={classes.noData}>Pro images url not available</div>}     
            </div>
          </DialogContent>
        </Dialog>
      </div>
    )
}

export default compose(withStyles(styles))(ProImages);
